import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

export default (props: SvgIconProps) => <SvgIcon {...props}>
  <svg viewBox="0 0 1000 1000">
    <path d="M696,344.4l109.5-109.5l-46.1-46.1L649.9,298.2L546.1,194.5v265.2h265.2L696,344.4z M304,655.6L194.5,765.2l46.1,46.1l109.5-109.5l109.5,109.5V546.1H194.5L304,655.6z M73.4,621.1H10V990h368.9v-63.4H73.4V621.1z M73.4,73.4h305.5V10H10v368.9h63.4V73.4z M926.6,926.6H621.1V990H990V621.1h-63.4V926.6z M621.1,10v63.4h305.5v305.5H990V10H621.1z" />
  </svg>
</SvgIcon>
